import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const swiper = new Swiper('.service-slider__slider', {
  slidesPerView: 3,
  spaceBetween: 25,

  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    767: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 3,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});



// WEBPACK FOOTER //
// ./scripts/partials/results.js